const swagger = {
    invalid_zod_type: 'Tipo Zod non valido. Controllare la configurazione di guardia del percorso.',
    not_supported_zod_type_for_params: 'Tipo Zod non supportato per i parametri. Controllare la configurazione di guardia del percorso.',
};
export default Object.freeze(swagger);
